import React from 'react';
import './StandardsPage.css';

const ACTIVITY_AREAS = [
  'Kalite yönetim sistemlerinin tasarlanması ve uygulanması',
  'Süreç analizleri ve performans ölçümleri',
  'İç denetim ve uygunluk değerlendirme çalışmaları',
  'Düzeltici ve önleyici faaliyetlerin planlanması',
  'Risk temelli kalite yönetimi uygulamaları',
  'Sürekli iyileştirme ve verimlilik çalışmaları',
  'Tedarikçi kalite yönetimi',
  'Ürün, hizmet ve süreç uygunluğunun izlenmesi',
  'Kalite raporları ve teknik değerlendirmelerin hazırlanması',
];

const DUTIES = [
  'Kurumsal kalite politikaları doğrultusunda kalite hedeflerinin belirlenmesine katkı sağlamak',
  'Kalite yönetim sistemlerinin etkin şekilde işletilmesini sağlamak',
  'Süreçlerin kalite kriterlerine uygunluğunu izlemek ve değerlendirmek',
  'Denetim planlarını hazırlamak ve uygulamak',
  'Tespit edilen uygunsuzluklara yönelik iyileştirici faaliyetleri koordine etmek',
  'Kalite performans göstergelerini analiz etmek ve raporlamak',
  'İlgili birimlerle koordinasyon içinde çalışarak kalite kültürünün yaygınlaşmasını sağlamak',
];

const AUTHORITIES = [
  'Kalite ile ilgili süreçlerde inceleme ve değerlendirme yapma',
  'Gerekli görülen durumlarda iyileştirme önerileri sunma',
  'Denetim ve gözden geçirme faaliyetlerini yürütme',
  'Kalite kayıt ve dokümantasyonunu talep etme',
  'Kalite süreçlerine ilişkin teknik görüş bildirme',
];

const TECHNICAL_COMPETENCIES = [
  'Kalite yönetim sistemleri bilgisi',
  'Süreç yönetimi ve analiz teknikleri',
  'Risk değerlendirme yöntemleri',
  'Ölçme, analiz ve raporlama becerileri',
  'Standart ve mevzuat okuryazarlığı',
];

const BEHAVIORAL_COMPETENCIES = [
  'Analitik düşünme',
  'Sistematik çalışma yaklaşımı',
  'İletişim ve koordinasyon becerisi',
  'Etik ilkelere bağlılık',
  'Sürekli gelişim bilinci',
];

const StandardsPage = () => {
  return (
    <div className="standards-page page-wrapper">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Kalite Mühendisi Meslek Standardı</h1>
          <p className="page-hero-subtitle">
            TKMB – Türkiye Kalite Mühendisleri Birliği
          </p>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
        <section className="content-section standard-section">
            <h2 className="standard-section-num">1. AMAÇ VE KAPSAM</h2>
            <p>
              Bu meslek standardı; kalite mühendisliği alanında faaliyet gösteren profesyonellerin görev, yetki, sorumluluk ve yetkinlik alanlarını tanımlamak, mesleki uygulamalarda ortak bir anlayış ve terminoloji oluşturmak ve kalite mühendisliği disiplininin kurumsal çerçevesini belirlemek amacıyla hazırlanmıştır.
            </p>
            <p>
              Standart; sanayi, üretim, hizmet ve teknoloji sektörlerinde görev alan kalite mühendislerinin yürüttüğü faaliyetleri kapsar ve kalite yönetim sistemleri, süreç yönetimi, uygunluk değerlendirme, sürekli iyileştirme ve risk temelli yaklaşımlar çerçevesinde uygulanır.
            </p>
          </section>

          <section className="content-section standard-section">
            <h2 className="standard-section-num">2. MESLEĞİN TANIMI</h2>
            <p>
              Kalite Mühendisi; kurum ve kuruluşlarda kalite yönetim sistemlerinin kurulması, uygulanması, sürdürülmesi ve geliştirilmesine yönelik çalışmaları planlayan, yürüten ve izleyen; süreçlerin belirlenen kalite kriterlerine uygunluğunu sağlayan, sürekli iyileştirme faaliyetlerini koordine eden meslek mensubudur.
            </p>
            <p>
              Kalite mühendisi; kaliteyi yalnızca ürün veya hizmet çıktısı olarak değil, organizasyonun tüm süreçlerine entegre edilmiş stratejik bir yönetim unsuru olarak ele alır.
            </p>
          </section>

          <section className="content-section standard-section">
            <h2 className="standard-section-num">3. FAALİYET ALANLARI</h2>
            <p>Kalite mühendisleri aşağıdaki ana faaliyet alanlarında görev yapar:</p>
            <ul className="standard-list">
              {ACTIVITY_AREAS.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="content-section standard-section">
            <h2 className="standard-section-num">4. GÖREV VE SORUMLULUKLAR</h2>
            <p>Kalite mühendisinin temel görev ve sorumlulukları şunlardır:</p>
            <ul className="standard-list">
              {DUTIES.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="content-section standard-section">
            <h2 className="standard-section-num">5. YETKİLER</h2>
            <p>Kalite mühendisi;</p>
            <ul className="standard-list">
              {AUTHORITIES.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p className="standard-note">yetkilerine sahiptir.</p>
          </section>

          <section className="content-section standard-section">
            <h2 className="standard-section-num">6. MESLEKİ YETKİNLİKLER</h2>
            <h3 className="standard-subtitle">Teknik Yetkinlikler:</h3>
            <ul className="standard-list">
              {TECHNICAL_COMPETENCIES.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <h3 className="standard-subtitle">Mesleki ve Davranışsal Yetkinlikler:</h3>
            <ul className="standard-list">
              {BEHAVIORAL_COMPETENCIES.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="content-section standard-section">
            <h2 className="standard-section-num">7. EĞİTİM VE MESLEKİ GELİŞİM</h2>
            <p>
              Kalite mühendisleri; mesleki bilgi ve becerilerini güncel tutmak amacıyla kalite yönetimi, denetim, süreç iyileştirme ve ilgili teknik alanlarda sürekli mesleki gelişim faaliyetlerine katılım sağlamalıdır.
            </p>
          </section>

          <section className="content-section standard-section">
            <h2 className="standard-section-num">8. MESLEK ETİĞİ VE MESLEKİ İLKELER</h2>
            <p>
              Kalite mühendisleri mesleki faaliyetlerini yürütürken tarafsızlık, gizlilik, doğruluk, teknik yeterlilik ve kurumsal sorumluluk ilkelerine uygun hareket eder.
            </p>
          </section>

          <section className="content-section standard-section">
            <h2 className="standard-section-num">9. MESLEĞİN STRATEJİK ÖNEMİ</h2>
            <p>
              Kalite mühendisliği; rekabet gücünün artırılması, kaynakların etkin kullanımı, müşteri memnuniyeti ve sürdürülebilir kurumsal yapıların oluşturulmasında stratejik bir rol üstlenmektedir.
            </p>
          </section>

          <section className="content-section standard-section">
            <h2 className="standard-section-num">10. UYGULAMA VE REFERANS</h2>
            <p>
              Bu meslek standardı, kalite mühendisliği alanında yürütülen çalışmalarda referans doküman olarak kullanılmak üzere hazırlanmıştır.
            </p>
          </section>

          <section className="content-section standard-section standards-certificate-section">
            <h2 className="standard-section-num">Mesleki Yetkinlik Belgesi</h2>
            <p>
              TKMB, meslek standardında tanımlanan yetkinlikleri taşıyan ve sicil sistemine kayıtlı kalite mühendislerine <strong>Kalite Mühendisliği Mesleki Yetkinlik Belgesi</strong> düzenlemektedir. Bu belge, mesleki bilgi, deneyim ve teknik yeterliliğin değerlendirilmesi sonucunda verilir.
            </p>
            <div className="certificate-sample">
              <img src="/meslekiyetkinlikbelgesi.jpeg" alt="TKMB Mesleki Yetkinlik Belgesi örnek görünüm" className="certificate-image" />
              <p className="certificate-caption">Mesleki Yetkinlik Belgesi örnek görünüm</p>
            </div>
          </section>

        <p className="contact-cta">
          Standartlar ve rehberler hakkında bilgi almak için{' '}
          <a href="mailto:info@tkmb.org">info@tkmb.org</a> adresinden iletişime geçebilirsiniz.
        </p>
        </div>
      </div>
    </div>
  );
};

export default StandardsPage;
